<template>
  <nav class="bg-white shadow">
    <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex px-2 lg:px-0">
          <div class="flex-shrink-0 flex items-center">
            <a href="/">
              <the-logo class="hidden lg:block text-primary-500 w-12 h-12" />
              <the-logo class="block lg:hidden text-primary-500 w-12 h-12" />
            </a>
          </div>
        </div>
        <div
          class="flex-1 flex items-center justify-center px-2 lg:ml-6 lg:justify-start"
        >
          <!-- search -->
          <!-- <div class="max-w-lg w-full lg:max-w-xs">
            <label for="search" class="sr-only">Search</label>
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  class="h-5 w-5 text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                id="search"
                class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-blue-300 focus:ring-blue sm:text-sm transition duration-150 ease-in-out"
                placeholder="Search"
                type="search"
              />
            </div>
          </div> -->
        </div>
        <div class="flex items-center lg:hidden">
          <button
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
            aria-label="Main menu"
            aria-expanded="false"
            @click="toggleMenu"
          >
            <MenuIcon v-if="!menuOpen" class="h-6 w-6" />
            <XIcon v-if="menuOpen" class="h-6 w-6" />
          </button>
        </div>
        <div class="hidden lg:ml-4 lg:flex lg:items-center">
          <!-- Profile dropdown -->
          <div class="ml-4 relative flex-shrink-0">
            <div>
              <button
                class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-primary-100 transition duration-150 ease-in-out"
                id="user-menu"
                aria-label="User menu"
                aria-haspopup="true"
                @click.prevent.stop="toggleDropdown"
                v-click-outside="closeDropdown"
              >
                <UserCircleIcon
                  v-if="!userId || !avatar"
                  class="h-8 w-8 text-secondary-200"
                />
                <img
                  v-else
                  class="w-8 h-8 rounded-full"
                  :src="avatar"
                  alt="Avatar"
                />
              </button>
            </div>

            <transitionDropDown>
              <div
                v-show="dropDownOpen"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
              >
                <div
                  class="py-1 rounded-md bg-white ring-1 ring-black ring-opacity-5"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >
                  <a
                    v-if="userId"
                    href="/apps/dashboard"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    role="menuitem"
                  >
                    {{ $t('My Profile') }}
                  </a>
                  <a
                    v-if="userId"
                    href="/apps/dashboard/purchases/"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    role="menuitem"
                  >
                    {{ $t('Purchases') }}
                  </a>
                  <span
                    v-if="userId"
                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    role="menuitem"
                    @click.prevent="logout"
                  >
                    {{ $t('Sign out') }}
                  </span>
                  <span
                    v-if="!userId"
                    class="cursor-pointer block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                    role="menuitem"
                    @click.prevent="login"
                  >
                    {{ $t('Sign in') }}
                  </span>
                </div>
              </div>
            </transitionDropDown>
          </div>
        </div>
      </div>
    </div>
    <transitionExpand>
      <div v-if="menuOpen" class="lg:hidden">
        <div class="pt-4 pb-3 border-t border-gray-200">
          <div>
            <a
              v-if="userId"
              href="/apps/dashboard"
              class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
            >
              {{ $t('My Profile') }}
            </a>
            <a
              v-if="userId"
              href="/apps/dashboard/purchases/"
              class="mt-1 block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
            >
              {{ $t('Purchases') }}
            </a>
            <a
              v-if="userId"
              @click.prevent="logout"
              class="mt-1 block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
            >
              {{ $t('Sign out') }}
            </a>
            <a
              v-else
              @click.prevent="login"
              class="cursor-pointer mt-1 block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100 transition duration-150 ease-in-out"
            >
              {{ $t('Sign in') }}
            </a>
          </div>
        </div>
      </div>
    </transitionExpand>
  </nav>
</template>

<i18n>
en:
  My Profile: My Profile
  Purchases: Purchases
  Sign out: Sign out

de:
  My Profile: Mein Profil
  Purchases: Käufe
  Sign out: Abmelden
</i18n>

<script>
import axios from 'axios'
import { sync, get, call } from 'vuex-pathify'
import ClickOutside from 'vue-click-outside'
import theLogo from '@/views/globals/logo.vue'
import transitionDropDown from '@/components/transitions/dropDown.vue'
import transitionExpand from '@/components/transitions/TransitionExpand.vue'
import { UserCircleIcon, MenuIcon, XIcon } from '@vue-hero-icons/outline'

export default {
  components: {
    theLogo,
    UserCircleIcon,
    MenuIcon,
    XIcon,
    transitionDropDown,
    transitionExpand
  },

  data() {
    return {
      dropDownOpen: false,
      menuOpen: false
    }
  },

  computed: {
    userId: sync('user/userId'),
    avatar: get('user/avatar')
  },

  methods: {
    gotoLogin: call('user/gotoLogin'),
    async logout() {
      try {
        await axios.get('/api/private/logout')
        window.location.href = '/'
      } catch (_) {}
    },

    login() {
      this.gotoLogin({ locale: this.$i18n.locale })
    },

    closeMenu() {
      this.menuOpen = false
    },

    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },

    closeDropdown() {
      this.dropDownOpen = false
    },

    toggleDropdown() {
      this.dropDownOpen = !this.dropDownOpen
    }
  },

  directives: {
    ClickOutside
  }
}
</script>
